__turbopack_context__.v({
  "blocksBackgroundColor": "ElementSpacer-module-scss-module__YMMV3q__blocksBackgroundColor",
  "blocksFontColor": "ElementSpacer-module-scss-module__YMMV3q__blocksFontColor",
  "elementSpacer": "ElementSpacer-module-scss-module__YMMV3q__elementSpacer",
  "secondaryNavBackgroundColor": "ElementSpacer-module-scss-module__YMMV3q__secondaryNavBackgroundColor",
  "themeBackgroundColor": "ElementSpacer-module-scss-module__YMMV3q__themeBackgroundColor",
  "themeFontColor": "ElementSpacer-module-scss-module__YMMV3q__themeFontColor",
});
